module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"isTyping":"{name} is typing...","areTyping":"{commaSeparatedNames} and {lastPersonName} are typing..."},"es":{"isTyping":"{name} está escribiendo...","areTyping":"{commaSeparatedNames} y {lastPersonName} están escribiendo..."}}')
  delete Component.options._Ctor
}
